import { useState, useEffect } from "react";
import { Container } from "./styles";
import AutoPlaySilentVideo from "../../AutoPlaySilentVideo";
import useClickedOutside from "../../../hooks/useClickedOutside";
import Project from "../../../models/Project";
import { useHistory } from "react-router-dom";
import UserData from "../../../models/UserData";
import { useAppStore } from "../../../stores/appStore";

export default function Onboarding({ plugin, dismiss }) {
  const [firstProject, setFirstProject] = useState(null);
  const history = useHistory();
  const user = useAppStore((state) => state.user);

  useEffect(() => {
    Project.getFirst(user.uid).then((firstProject) => {
      setFirstProject(firstProject);
    });
  }, []);

  const ref = useClickedOutside(() => {
    dismiss();
  });

  // determine if plugin uses highlight
  let cursor = true;
  if (plugin.usesHighlightedText) {
    cursor = false;
  }

  return (
    <Container
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {cursor && (
        <AutoPlaySilentVideo
          mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/plugins/cursor_plugin_onboarding.mp4"
          webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/plugins/cursor_plugin_onboarding.webm"
          immediate={true}
        />
      )}
      {!cursor && (
        <AutoPlaySilentVideo
          mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/plugins/highlight_plugin_onboarding.mp4"
          webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/plugins/highlight_plugin_onboarding.webm"
          immediate={true}
        />
      )}

      {cursor && <div className="text-content">To use your plugin, position your cursor in a document, then open the Plugins menu and click the plugin name.</div>}
      {!cursor && <div className="text-content">To use your plugin, highlight text in a document, then open the Plugins menu and click the plugin name.</div>}
      {firstProject && (
        <button
          className="try"
          onClick={async (e) => {
            const userData = new UserData(user.uid);
            await userData.fetch();
            await userData.update({ showPluginTip: true });

            if (firstProject) {
              history.push("/app/project/" + firstProject.id);
            } else {
              history.push("/app");
            }
          }}
        >
          Try it out {"->"}
        </button>
      )}
    </Container>
  );
}
